import { InjectionToken } from '@angular/core'

import { AuthService } from '../auth/auth.service'

export const AUTH_SERVICE = new InjectionToken<AuthService>('AUTH_SERVICE')
